import { Navigate, Outlet } from 'react-router-dom';

import { ANY_SPORT_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

import { ImportLineup } from '@sorare/gameplay/src/components/importLineup/ImportLineup';

const Layout = () => {
  const { generateSportContextPath } = useSportContext();
  const { currentUser } = useCurrentUserContext();

  // Make sure existing users who are logged in are redirected to the home page
  if (!currentUser?.anyUserSportProfile?.onboarded) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_HOME)} replace />;
  }

  return (
    <RequireAuth>
      <Outlet />
      <ImportLineup />
    </RequireAuth>
  );
};

export default Layout;
